import { getCatalogEntry } from '@/config/onboardPricingCatalog';

export interface ComparisonRow {
  name: string;
  free: string;
  professional: string;
  enterprise: string;
}

/**
 * RC's AI headline rows for the feature-comparison dialog, derived from the
 * shared onboarding catalog so the dialog can never drift from the plan
 * cards (spec C2: one definition per datum).
 */
export function rcAiComparisonRows(): ComparisonRow[] {
  const entry = getCatalogEntry('replenishment_plus');
  return (entry ? entry.features : [])
    .filter((f) => f.aiTag)
    .map((f) => ({ name: f.text, free: '−', professional: '−', enterprise: '✓' }));
}
